import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit {

  @Input() title: string = '';
  @Input() footer: string = '';
  @Input() chartData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
